import $ from "jquery";
export function companyDataValidate( props ){
    $("[data-ctr]").removeClass("has-error")
    $("[data-ctr]").removeClass("has-success")
    $("[data-company-data]").removeClass("has-success")
    $("[data-company-data]").removeClass("has-success")

    let errors = []

    return errors


}


// WEBPACK FOOTER //
// ./src/components/parts/utils/company-validator.js